import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {ChronoField, DateTimeFormatter, use} from "js-joda";
import {Observable} from "rxjs/Observable";
import {AppointmentsService} from "../../Services/appointments/appointments.service";
import {CookieService} from 'angular2-cookie/services/cookies.service';
import {DesktopAddToCalendarComponent} from '../desktop-add-to-calendar/desktop-add-to-calendar.component';
import {scrollToElement} from '../../helpers';

declare var require: any;
use(require('js-joda-timezone'));

@Component({
  selector: 'app-youre-all-set',
  templateUrl: './youre-all-set.component.html',
  styleUrls: ['./youre-all-set.component.scss']
})
export class YoureAllSetComponent implements OnInit {

  weekConvert = {
    1: 'Monday',
    2: 'Tuesday',
    3: 'Wednesday',
    4: 'Thursday',
    5: 'Friday',
    6: 'Saturday',
    7: 'Sunday',
  };
  monthConvert = {
    1: 'January',
    2: 'Febuary',
    3: 'March',
    4: 'April',
    5: 'May',
    6: 'June',
    7: 'July',
    8: 'August',
    9: 'September',
    10: 'October',
    11: 'November',
    12: 'December',
  };

  addToCalendar = false;
  addToCalendarComponent = DesktopAddToCalendarComponent;
  title = 'You Are All Set!';
  DAY_OF_MONTH = ChronoField.DAY_OF_MONTH;
  DAY_OF_WEEK = ChronoField.DAY_OF_WEEK;
  MONTH_OF_YEAR = ChronoField.MONTH_OF_YEAR;
  HOUR_OF_DAY = ChronoField.HOUR_OF_DAY;
  YEAR = ChronoField.YEAR;
  ofPattern = DateTimeFormatter.ofPattern;
  outlookLink = '';
  appLocation = '';
  confirmation_text1 = '';
  confirmation_text2 = '';
  confirmation_text3 = '';
  monthly = 'no';
  aptMinutes = '60';

  @Output() close = new EventEmitter();

  @Output() openCancelDemo = new EventEmitter();

  appointmentService: AppointmentsService;

  @Input() dateTimeInfo;

  @Output() openCalendar = new EventEmitter();

  constructor(appointmentService: AppointmentsService) {
    this.appointmentService = appointmentService;
    this.outlookLink = this.appointmentService.appointmentOutlook;
    this.appLocation = this.appointmentService.appointmentLocation;
    if ( window['ngRoot'] !== null ) {
      this.monthly = window['ngRoot'].getAttribute('data-monthly') || 'no';
      this.confirmation_text1 = window['ngRoot'].getAttribute('data-confirm1') || '';
      this.confirmation_text2 = window['ngRoot'].getAttribute('data-confirm2') || '';
      this.confirmation_text3 = window['ngRoot'].getAttribute('data-confirm3') || '';
      this.aptMinutes = window['ngRoot'].getAttribute('data-minutes') || '60';
    }
  }

  ngOnInit() {
  }

  reschedule() {
    // document.getElementById('acuitycal-container').scrollIntoView();
    scrollToElement('#acuitycal-container', -140);

    this.openCalendar.emit();
  }

  openCancelDemoFunc($event) {
    // document.getElementById('acuitycal-container').scrollIntoView();
    scrollToElement('#acuitycal-container', -140);

    this.openCancelDemo.emit($event)
  }

  googleLink() {
    var postID = '';
    if (window['ngRoot'] !== null) {
      postID = window['ngRoot'].getAttribute('data-postid');
    }
    var dt1 = this.dateTimeInfo.finalDate;
    var dt2 = this.dateTimeInfo.finalDate.plusMinutes(this.aptMinutes);
    var google_dt1 = new Date(dt1.toLocalDate().toString()+"T"+dt1.toLocalTime().toString()+":00"+this.dateTimeInfo.timezone.time.slice(0,3)+":00").toISOString().split('.')[0].replace(/[-:+]/g, '')+"Z";
    var google_dt2 = new Date(dt2.toLocalDate().toString()+"T"+dt2.toLocalTime().toString()+":00"+this.dateTimeInfo.timezone.time.slice(0,3)+":00").toISOString().split('.')[0].replace(/[-:+]/g, '')+"Z";
    var url = 'https://calendar.google.com/calendar/render?action=TEMPLATE&text=';
    url += 'Live SharpSpring Demo&'.replace(/ /g, "+");
    url += 'dates=' + google_dt1 + '/' + google_dt2 + '&';
    url += 'location=' + encodeURIComponent(this.appLocation).replace(/%20/g, "+").replace(/\(/g, "%28").replace(/\)/g, "%29") + '&';
    url += 'details=' + encodeURIComponent(this.appLocation + '\n\
\nView/Change Appointment:\n' + encodeURI('https://sharpspring.com/wp-content/plugins/acuity-scheduling-angular/api/get_appointment_info.php?apt_id='+window['appointmentID']+'&post_id='+postID) + '\n\
\nWe are looking forward to chatting with you and showing you how SharpSpring marketing automation can help you grow your business.\n\
\nIn the meantime, check out some of our featured resources.\n\
\nTake Your Agency and Clients to the Next Level\nB2B and B2C Strategies\n\
\nDriving Growth & Producing Measurable Results\nInfographic\n\
\nMarketing Automation Playbook\nPump up your Campaigns\n\
\nGoogle').replace(/%20/g, "+").replace(/\(/g, "%28").replace(/\)/g, "%29");
    url += '&sf=true&output=xml';
    return url;
    // View/Change Appointment:\n' + this.outlookLink.slice(0, -6).replace(/id%5B%5D/g, "id[]")
  }

}



// WEBPACK FOOTER //
// /app/src/app/Components/youre-all-set/youre-all-set.component.ts